<div class="pc-content" style="background:white; padding: 10px">
    <div class="pc-content-item1">
         <kendo-floatinglabel  class="pc-k-textbox-container" text="New Category Name">
            <kendo-textbox  
                         class="newCategoryName"
                         (valueChange)="newCategoryTextBoxChanged($event)"
                         [(ngModel)]="newCategoryTextValue">
            </kendo-textbox>
        </kendo-floatinglabel> 
        <div class="buttonInline">
            <app-mcl-button (buttonPressed)="addCategoryClicked()" primary="true" text="Add Category"></app-mcl-button>
        </div>
        <kendo-grid
            #allCategoryItemsGrid
            (dataStateChange)="dataStateChange($event)"
            (pageChange)="pageChange($event)"
            [data]="gridData"
            [filter]="state.filter"
            [filterable]="true"
            [kendoGridSelectBy]="selectedCallback"
            (selectedKeysChange)="keyChangeAdd($event)"
            [navigable]="true"
            [reorderable]="true"
            [resizable]="true"
            [selectable]="true"
            [selectedKeys]="allItemsSelected"
            [skip]="state.skip"
            [sort]="state.sort"
            [sortable]="true"
            id="grid-category"
            style="height: 65vh">
            <kendo-grid-column *ngFor="let col of columns"
                               [editable]="false"
                               [field]="col.field"
                               [filterable]="col.filterable"
                               [format]="col.format"
                               [media]="col.media"
                               [title]="col.title"
                               [width]="col.width"
                               filterable="true"
                               headerClass="HeaderGrid">
                <ng-template kendoGridFooterTemplate let-column let-columnIndex="columnIndex">
                    <p *ngIf="gridData">
                        {{totalItemsInTable}} Item(s)</p>

                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [title]="'Description'" field="description" filterable="true" width="240">
            </kendo-grid-column>
        </kendo-grid>
    </div>
    <div class="pc-content-item2">
        <app-mcl-button (buttonPressed)="copyBtnClicked()" class="pc-center-buttons" primary="true"
                    text="Copy >>> &nbsp;&nbsp;"></app-mcl-button>
        <p></p>
        <app-mcl-button (buttonPressed)="removeBtnClicked()" class="pc-center-buttons" primary="true"
                    text="<<< Remove"></app-mcl-button>
    </div>
    <div class="pc-content-item3">
        <p class="deleteCategoryParagraph">Select a Category</p>
        <kendo-dropdownlist (valueChange)="selectedCategoryOption($event)"
                            [(ngModel)]="selectedCategory"
                            [data]='_profileCategoriesService.profileCategoryCategoriesListView'
                            class='pc-k-dropdownlist'>
        </kendo-dropdownlist>
        <div class="buttonInline">
            <app-mcl-button (buttonPressed)="deleteCategoryClicked()" primary="true" text="Delete Category"></app-mcl-button>
        </div>
        <kendo-grid
            #itemsInCategoryGrid
            (dataStateChange)="dataStateChangeCategory($event)"
            (pageChange)="pageChangeCategory($event)"
            [data]="gridDataForCategory"
            [filter]="stateCategory.filter"
            [filterable]="true"
            [kendoGridSelectBy]="selectedCallbackItems"
            [navigable]="true"
            [reorderable]="true"
            [resizable]="true"
            [selectable]="true"
            (selectedKeysChange)="keyChangeRemove($event)"
            [selectedKeys]="categoryItemsSelected"
            [skip]="stateCategory.skip"
            [sort]="stateCategory.sort"
            [sortable]="true"
            id="grid-items-in-category"
            style="height: 66vh">
            <kendo-grid-column *ngFor="let col of columns" [editable]="false" [field]="col.field"
                               [filterable]="col.filterable" [format]="col.format"
                               [media]="col.media"
                               [title]="col.title" [width]="col.width"
                               headerClass="HeaderGrid">
                <ng-template kendoGridFooterTemplate let-column let-columnIndex="columnIndex">
                    <p *ngIf="gridData">
                        {{totalItemsInTableCategory}} Item(s)</p>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [title]="'Description'" field="description" filterable="true" width="240">
            </kendo-grid-column>
        </kendo-grid>

        <div class="buttonflex">
            <app-mcl-button (buttonPressed)="profileService.saveAllItems()"
                        [disabled]="!profileService.itemsSaved"
                        inprogressMessage="Saving"
                        primary="true"
                        text="Save Items">
            </app-mcl-button>
        </div>
    </div>
</div>
<div kendoDialogContainer></div>
